module.exports = __webpack_public_path__ + "img/logo.34d5dbb2.png";